import * as React from "react";
import { DataEntryComponentProps, DataItem, TemplateData } from "../types";
import ComponentAssociatedText from "./componentAssociatedText";
import { RunningTemplateContext } from "../context";

type AdditionalDataEntryComponentProps = DataEntryComponentProps & {
    dataItem?: DataItem;
    applyPropertyUpdate: (obj) => any;
    getComponentHasValue?: (templateData: TemplateData) => boolean;
    updatePropertyValidity: (propertyName: string, isValid: boolean) => void;
};

const AdditionalDataEntryComponent = (props: AdditionalDataEntryComponentProps) => {
    const { templateData = {} } = React.useContext(RunningTemplateContext);
    const { id, onChange, dataItem = templateData[id], applyPropertyUpdate, updatePropertyValidity } = props;

    const setProperty = (propertyName: string, propertyValue: any, isValid: boolean) => {
        onChange({ [id]: applyPropertyUpdate({ [propertyName]: propertyValue }) });
        updatePropertyValidity(propertyName, isValid);
    };

    const setAssociatedText = (associatedText: string) => {
        setProperty("associatedText", associatedText, true);
    };

    return (
        <div className="additional-data-entry">
            <ComponentAssociatedText {...props} text={dataItem?.associatedText} onTextChange={setAssociatedText} />
        </div>
    );
};

export default AdditionalDataEntryComponent;
